import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, tap } from 'rxjs/operators';
import { untilDestroyed } from '@app/core';

import { User } from '@app/models';
import { ErrorHandlerService, NotyService, UserService, WhitelabelService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';

export type ModalResult = {};
export interface ModalPublicProperties {}

@Component({
  selector: 'app-whitelabel-opengraph-modal',
  templateUrl: './whitelabel-opengraph-modal.component.html',
  styleUrl: './whitelabel-opengraph-modal.component.scss',
  standalone: false
})
export class WhitelabelOpengraphModalComponent implements ModalPublicProperties, OnInit, OnDestroy {
  @Input() url: string;
  @Input() title: string;
  @Input() description: string;

  form: UntypedFormGroup;
  currentUser: User;
  isLoading = true;

  constructor(
    public modal: NgbActiveModal,
    public translateService: TranslateService,
    public userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private notyService: NotyService,
    private whitelabelService: WhitelabelService
  ) {
    this.form = this.formBuilder.group({
      url: '',
      title: '',
      description: ''
    });
  }

  ngOnInit() {
    this.isLoading = true;

    this.userService
      .watchCurrentUser()
      .pipe(
        filter(user => !!user),
        untilDestroyed(this),
        tap(user => (this.currentUser = user))
      )
      .subscribe({
        next: () => {
          this.form.patchValue({
            url: this.url || '',
            title: this.title || '',
            description: this.description || ''
          });
          this.isLoading = false;
        }
      });
  }

  ngOnDestroy() {}

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let { url, title, description } = this.form.value;

    this.whitelabelService
      .updateWhitelabelOpenGraph({
        whitelabelOpengraph: {
          og_title: title,
          og_image: url,
          og_description: description
        }
      })
      .subscribe({
        next: updated => {
          this.modal.close(updated);
          this.notyService.success(this.translateService.instant('notyService.opengraphUpdate'));
        },
        error: err => {
          this.errorHandlerService.handle(err);
        }
      });
  }

  cancel() {
    this.modal.close({} as ModalResult);
  }
}
